import styled from "styled-components";

export const HeaderWrapper = styled.div`
  width: 100%;
  height: 60px;
  display: flex;

  align-items: center;
  color: #fff;
  background-color: var(--bkg-primary);
  text-align: center;
  padding: 18px 18px 18px 36px;
`;
export const CoinWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  a:hover {
    cursor: pointer;
    color: var(--main-color);
  }
`;
export const CoinAmount = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  & span {
    color: var(--text-secondary);
  }
  & span.buy-credit-span:hover {
    cursor: pointer;
    color: var(--main-color);
  }
`;
export const CoinNumber = styled.div`
  font-weight: 600;
  background-color: var(--bkg-quaternary);
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
`;
export const CoinDivider = styled.div`
  height: 32px;
  width: 2px;
  background: var(--main-color);
`;
